"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageStatisticsResultsContainerComponent = UsageStatisticsResultsContainerComponent;
const React = __importStar(require("react"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const clipboard = __importStar(require("@genesys/client-core/lib/browsertools/clipboard"));
const DateHelper = __importStar(require("@genesys/shared/lib/date-helper"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const UserProfile = __importStar(require("@genesys/client-core/lib/user-profile"));
const Actions = __importStar(require("../actions"));
const UsageStatisticsResultsComponent = __importStar(require("./components/usage-statistics-results-component"));
const SystemStatusEnum = __importStar(require("@genesys/shared/lib/enums/system-status"));
const searchQueryGQL = (0, graphql_tag_1.default) `
  query UsageStatisticsResultContainerComponent_UsageSearch(
    $filter: UsageSearchFilterInputType!
  ) {
    user {
      usageSearch(filter: $filter) {
        id
        results {
          id
          salesOrganisationId
          systemTypeId
          statusId
          userName
          userFullName
          date
          isDeleted
          systemsCount
          lastUsage
          genesysNoString
        }
      }
    }
  }
`;
function UsageStatisticsResultsContainerComponent({ activeSystemTypes, currentPage, dispatch, salesOrganisations, searchOptions }) {
    return (React.createElement(UserProfile.UserProfile, null, ({ locale }) => (React.createElement(GraphQLQuery.QueryUserSimple, { query: searchQueryGQL, variables: {
            filter: {
                salesOrganisations: searchOptions.selectedSalesOrganisations,
                salesOrganisationFilter: searchOptions.salesOrganisationFiltering,
                salesOrganisationGroup: searchOptions.salesOrganisationGrouping,
                systemTypes: searchOptions.selectedSystemTypes,
                systemTypeFilter: searchOptions.systemTypeFiltering,
                systemTypeGroup: searchOptions.systemTypeGrouping,
                status: searchOptions.selectedStatus,
                statusFilter: searchOptions.statusFiltering,
                statusGroup: searchOptions.statusGrouping,
                fromDate: searchOptions.selectedDateRange.start &&
                    DateHelper.toUTC(searchOptions.selectedDateRange.start),
                toDate: searchOptions.selectedDateRange.end &&
                    DateHelper.toUTC(searchOptions.selectedDateRange.end),
                dateFilter: searchOptions.dateRangeFiltering,
                dateGroup: searchOptions.dateRangeGrouping,
                username: searchOptions.selectedUsername,
                userFilter: searchOptions.usernameFiltering,
                userGroup: searchOptions.usernameGrouping,
                deleted: searchOptions.selectedDeletedSystems,
                deletedFilter: searchOptions.deletedSystemFiltering,
                deletedGroup: searchOptions.deletedSystemGrouping,
                includeGenesysNo: searchOptions.genesysNoShow
            }
        } }, ({ user: { usageSearch } }) => {
        const results = usageSearch.results.map((r, index) => ({
            id: `${index}`,
            salesOrganisation: r.salesOrganisationId
                ? salesOrganisations.find(so => so.id === r.salesOrganisationId).name +
                    " (" +
                    r.salesOrganisationId +
                    ")"
                : "",
            systemType: r.systemTypeId
                ? systemTypeStringFormat(activeSystemTypes, r.systemTypeId)
                : "",
            status: r.statusId !== null && r.statusId !== undefined
                ? SystemStatusEnum.SystemStatus[r.statusId]
                : "",
            date: r.date
                ? DateHelper.getDateString(DateHelper.fromUTC(r.date), locale)
                : "",
            user: r.userName
                ? usernameStringFormat(r.userName, r.userFullName || "")
                : "",
            deleted: r.isDeleted ? r.isDeleted.toString() : "",
            count: r.systemsCount.toString(),
            lastUsed: r.lastUsage
                ? DateHelper.getDateString(DateHelper.fromUTC(r.lastUsage), locale)
                : "",
            genesysNo: r.genesysNoString ? r.genesysNoString : ""
        }));
        const copyCallback = () => {
            const text = "Sales organisation\tSystem type\tStatus\tUser\tDate\tDeleted\tCount\tLast usage\tGenesys No" +
                results.reduce((a1, r) => a1 +
                    "\r\n" +
                    (r.salesOrganisation +
                        "\t" +
                        r.systemType +
                        "\t" +
                        r.status +
                        "\t" +
                        r.user +
                        "\t" +
                        r.date +
                        "\t" +
                        r.deleted +
                        "\t" +
                        r.count +
                        "\t" +
                        r.lastUsed +
                        "\t" +
                        r.genesysNo), "");
            clipboard.toClipboard(text);
        };
        const generateFileFormat = () => resultToFile(results);
        return (React.createElement(UsageStatisticsResultsComponent.UsageStatisticsResultsComponent, { results: results, copyCallback: copyCallback, generateFileFormat: generateFileFormat, currentPage: currentPage, itemsPerPage: 1000, changePageCallback: pageNumber => dispatch(Actions.createChangePageAction(pageNumber)), refreshCallback: () => {
                /*  */
            } }));
    }))));
}
function usernameStringFormat(username, userFullname) {
    return userFullname + " (" + username + ")";
}
function systemTypeStringFormat(systemTypes, systemTypeId) {
    const systemType = systemTypes.find(st => st.id === systemTypeId);
    return (systemType ? systemType.name + " " : "") + "(" + systemTypeId + ")";
}
function resultToFile(results) {
    return [
        [
            "Sales organisation",
            "System type",
            "Status",
            "User",
            "Date",
            "Deleted",
            "Count",
            "Last usage",
            "Genesys No"
        ]
    ].concat(results.map(r => [
        r.salesOrganisation,
        r.systemType,
        r.status,
        r.user,
        r.date,
        r.deleted,
        r.count,
        r.lastUsed,
        r.genesysNo
    ]));
}
//# sourceMappingURL=container-component.js.map